export function SET_SERVICE(state, service) {
  state.service = service;
}

export function SET_RECENT_USERS(state, recentUsers) {
  state.recentUsers = [...recentUsers];
}

export function SET_FAVORITE_USERS(state, favoriteUsers) {
  state.favoriteUsers = [...favoriteUsers];
}

export function SET_AUTHENTICATED_USER(state, user) {
  state.authenticatedUser = user;
}

export function SET_OPS_TOGGLES(state, opsToggles) {
  state.opsToggles = opsToggles;
}